<h2 class="h4 mt-0 mb-1">Forgot Password ?</h2>
<p [tcColor]="'#8f8f90'">Enter your registered email id to reset the password</p>

<forgot-form></forgot-form>